'use strict';

var ReactPDF = require('./react-pdf');

require('pdfjs-dist');
require('pdfjs-dist/web/compatibility');

module.exports = ReactPDF;


//////////////////
// WEBPACK FOOTER
// ./~/react-pdf/build/entry.js
// module id = 513
// module chunks = 1